"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.some");

var _react = _interopRequireDefault(require("react"));

var _legacyLink = _interopRequireDefault(require("./legacy-link"));

var _simpleLink = _interopRequireDefault(require("./simple-link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var deprecatedProps = ['bold', 'chronicle', 'color', 'decorated', 'italic', 'unstyled', 'uppercase'];
/**
 * To keep styles simple while also retaining backwards compatibility, this
 * component has been bifurcated into two internal components: `<SimpleLink>`
 * and `<LegacyLink>`. If no deprecated props are used, `<SimpleLink>` will be
 * rendered. Otherwise, `<LegacyLink>` will be used instead.
 *
 * During the next major version bump, `<LegacyLink>` should be removed and
 * `<SimpleLink>` should become the implementation of `<Link>`.
 */

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var needsLegacyLink = deprecatedProps.some(function (deprecatedProp) {
    return !!props[deprecatedProp];
  });

  if (needsLegacyLink) {
    return /*#__PURE__*/_react["default"].createElement(_legacyLink["default"], _extends({}, props, {
      ref: ref
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_simpleLink["default"], _extends({}, props, {
    ref: ref
  }));
});

var validSizes = [0, 1, 2, 3, 4, 5];
var linkLevelSizeMap = {
  small: 1,
  legal: '0'
};
Link.displayName = 'Link';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Link.propTypes = {
    /** Children string or components to render between <span>, or in place of <span>. */
    children: PropTypes.node,
    className: PropTypes.string,

    /**
     * Allows you to provide a React component or other HTML element,
     * overriding the default `a` and `button` options.
     */
    component: PropTypes.any,
    // eslint-disable-line react/forbid-prop-types

    /**
     * Whether or not to apply disabled styles. Note that this should only be
     * used when this component is rendering a `button`.
     */
    disabled: PropTypes.bool,
    gotham: PropTypes.bool,

    /** The URL to visit. */
    href: PropTypes.string,

    /**
     * Size of the link. Supports semantic "small" and "legal" or a numeric
     * scale from size 0 to 5.
     */
    size: PropTypes.oneOf([].concat(validSizes, _toConsumableArray(Object.keys(linkLevelSizeMap)))),

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool,

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its click or active styles. */
    dangerouslyForceActiveStyling: PropTypes.bool
  };
}

Link.defaultProps = {
  children: null,
  className: null,
  component: null,
  disabled: null,
  gotham: undefined,
  href: null,
  size: null,
  dangerouslyForceHoverStyling: false,
  dangerouslyForceFocusStyling: false,
  dangerouslyForceActiveStyling: false
};
var _default = Link;
exports["default"] = _default;